module.exports = __webpack_public_path__ + "img/map.155982f3.jpg";